import { render, staticRenderFns } from "./WriteMessage.vue?vue&type=template&id=36c2dc79&scoped=true"
import script from "./WriteMessage.vue?vue&type=script&lang=js"
export * from "./WriteMessage.vue?vue&type=script&lang=js"
import style0 from "./WriteMessage.vue?vue&type=style&index=0&id=36c2dc79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c2dc79",
  null
  
)

export default component.exports